import './style.less';
import templateATag from './template.a.html';
import templateBtn from './template.btn.html';
import modalTemplate from 'modals/reports/template.html';
import modalController from 'modals/reports/controller';
import moment from 'moment-timezone';

export default function($log, $sce, $stateParams, ProfileClass, ResolveClass, $uibModal) {
  'ngInject';

  const vm = this;

  vm.$onChanges = activate;

  const { company_id, profile_uid: profileClass_profile_uid } = ProfileClass.profileComplete.profile;
  const profile_uid = $stateParams.employeeID || $stateParams.id || profileClass_profile_uid;
  const manage = ResolveClass.isManageRoute();

  vm.loaded = false;

  vm.generateReport = () => {
    vm.laddaBtn = true;

    const params = {
      timezone: moment.tz.guess(),
      ...vm.ngModel
    };

    $uibModal
      .open({
        template: modalTemplate,
        controller: modalController({
          company_id,
          manage,
          params,
          profile_uid,
          report_type: vm.reportType
        }),
        size: 'sm',
        backdrop: true
      })
      .result.catch(error => {
        if (error === 'cancel' || error === 'backdrop click') return;
        $log.error(error);
      });

    vm.laddaBtn = false;
  };

  function activate() {
    $log.debug('Generate Reports Component Activated');

    if (!vm.ngModel) {
      vm.ngModel = {};
    }

    vm.loaded = true;

    vm.template = $sce.trustAsHtml({ aTag: templateATag, btn: templateBtn }[vm.style || 'btn']);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/generateReports/controller.js